/* globals $, controller */
import { TimelineMax, TweenMax } from 'gsap';
import 'gsap/ScrollToPlugin';

import ScrollMagic from 'helpers/importers/ScrollMagic';

export default function historyTooltipScene () {

  let tween = new TimelineMax();
  tween.add(TweenMax.to($('#history .mobile-tooltip'), 1, {
    autoAlpha: 0,
    delay: 2,
  }));

  let scene = new ScrollMagic.Scene({
    triggerElement: '#history',
    offset: 0,
    duration: 0,
    triggerHook: 'onEnter',
  })
  .setTween(tween);

  scene.addTo(controller);
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/scenes/historyTooltipScene.js